import React from 'react'

function Icon() {
  return (
    <svg
      width="21px"
      height="21px"
      viewBox="0 0 21 21"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Icon/breakfast</title>
      <defs>
        <linearGradient x1="50%" y1="0%" x2="50%" y2="100%" id="linearGradient-1">
          <stop stopColor="#61C685" offset="0%"></stop>
          <stop stopColor="#FFCC37" offset="100%"></stop>
        </linearGradient>
        <rect id="path-2" x="0" y="0" width="21" height="21" rx="10.5"></rect>
      </defs>
      <g id="Icon/breakfast" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Group-17">
          <mask id="mask-3" fill="white">
            <use xlinkHref="#path-2"></use>
          </mask>
          <use id="Rectangle" fill="url(#linearGradient-1)" xlinkHref="#path-2"></use>
          <path
            d="M10.5361201,4.00184498 C10.5192184,4.00503602 10.5023172,4.00982197 10.4869519,4.01460832 C10.3041077,4.0576847 10.1750413,4.22839448 10.1796509,4.42303521 L10.1796509,6.87359658 C10.1781145,7.020375 10.2518667,7.15758111 10.3747872,7.23256543 C10.4977076,7.30595484 10.6482849,7.30595484 10.7712053,7.23256543 C10.8941257,7.15758111 10.9678779,7.020375 10.9663415,6.87359658 L10.9663415,4.42303521 C10.9709511,4.30497452 10.9248558,4.19169977 10.8434211,4.11192869 C10.76045,4.0305627 10.6482849,3.99067695 10.5361201,4.00184498 Z M4.98011756,6.41411633 C4.82646704,6.43007071 4.69586421,6.53696338 4.64669604,6.68693283 C4.59599147,6.8384976 4.63594041,7.00601634 4.74656878,7.11610005 L6.40599431,8.83915101 C6.50125783,8.96040275 6.65337154,9.01624246 6.80087603,8.98114307 C6.94684412,8.94604409 7.0620821,8.82638767 7.09588502,8.6748229 C7.12968833,8.52166282 7.07591055,8.36371678 6.95913616,8.26480069 L5.29971062,6.54174973 C5.22595838,6.46038333 5.12454923,6.41571164 5.01699368,6.41411633 C5.00470164,6.41411633 4.9924096,6.41411633 4.98011756,6.41411633 Z M16.0798306,6.41411633 C15.9907135,6.42687967 15.907742,6.47314667 15.8462818,6.54174973 L14.1868563,8.26480069 C14.0700819,8.36371678 14.0163041,8.52166282 14.0501074,8.6748229 C14.0839103,8.82638767 14.1991483,8.94604409 14.3451164,8.98114307 C14.4926209,9.01624246 14.644735,8.96040275 14.7399981,8.83915101 L16.3994237,7.11610005 C16.516198,6.99963467 16.5515378,6.81935259 16.4885411,6.66459678 C16.4270809,6.50984138 16.2780396,6.41092569 16.1167067,6.41411633 C16.1044147,6.41411633 16.0921226,6.41411633 16.0798306,6.41411633 Z M10.5729962,8.50730416 C8.53712702,8.50730416 6.86233624,10.1218667 6.66412717,12.1831462 L-0.606654688,12.1831462 C-0.823301812,12.1831462 -1,12.365024 -1,12.5915731 C-1,12.8181226 -0.823301812,13 -0.606654688,13 L21.6066547,13 C21.8248386,13 22,12.8181226 22,12.5915731 C22,12.365024 21.8248386,12.1831462 21.6066547,12.1831462 L14.4818653,12.1831462 C14.2836562,10.1218667 12.6088654,8.50730416 10.5729962,8.50730416 Z"
            id="Shape"
            fill="#FFFFFF"
            fillRule="nonzero"
            mask="url(#mask-3)"
          ></path>
        </g>
      </g>
    </svg>
  )
}

export default Icon
